
import Vue from "vue";
import SubHeader from "@/views/layout/header/SubHeader.vue";
import Search from "@/components/Search.vue";
import CardNotification from "@/components/card/CardNotification.vue";
import { Component } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import NotificationModel from "@/models/NotificationModel";
import api from "@/api";
import utils from "@/utils";
import { UserModule } from "@/store/modules/user";
@Component({
  components: {
    SubHeader,
    Search,
    CardNotification,
    MenuFooter,
  },
})
export default class ListNotification extends Vue {
  mounted() {
    this.getListProgress();
  }
  titlePage = "Notification";
  utils = utils;

  displayLoading = true;
  displayNotifikasi = false;
  userDetail = UserModule.userDetail;

  listNotification: NotificationModel[] = [];
  getListProgress() {
    this.displayLoading = true;
    return new Promise((resolve, reject) => {
      api.notification
        .getListNotification()
        .then((response) => {
          if (response.data.code === 200) {
            this.listNotification = [...response.data.data.data];
            this.displayLoading = false;
            this.displayNotifikasi = true;
            resolve(response);
          }
        })
        .catch((err: any) => {
          reject(err);
          this.$swal("Error", err?.response?.data?.message, "error");
        });
    });
  }
  setReadNotification(id: number | null) {
    return new Promise((resolve, reject) => {
      api.notification
        .setReadNotification(id)
        .then((response) => {
          if (response.data.code === 200) {
            this.$router.push({
              path: (this.userDetail.accessgroup['name'] == 'User' ? "/detail-ticket/" + response.data.data.ticket_id :  '/ticket-detail-new/' + response.data.data.wo_id),
            });
            resolve(response);
          }
        })
        .catch((err: any) => {
          reject(err);
          this.$swal("Error", err?.response?.data?.message, "error");
        });
    });
  }
}
